// @flow
import * as React from 'react';
import { Text, Box, Button } from 'grommet';
import { Close } from 'grommet-icons';
import { injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import ActionButtons from 'esm-web-pro/components/forms/ActionButtons';
import PointAttributes from './PointAttributes';


type Props = {
    drawingObject: {
        provider: { entity: { name: string } },
        object: Object,
        resource: Object,
        gisResource: Object,
        data: { points: Array<Object> },
        formData: Object,
    },
    onPointRemove: (layer: Object) => void,
    onSubmit: Function,
    onClose: Function,
}

const PointForm = (props: Props) => {
    const {
        drawingObject: {
            provider, object, data: { points }, formData, formDisplayValues,
        }, onPointRemove, onSubmit, onClose,
    } = props;

    const pointsEndRef = React.useRef(null);

    const scrollToBottom = () => {
        if (pointsEndRef.current) {
            pointsEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    React.useEffect(() => {
        scrollToBottom();
    });

    return (
        <Box height="100%" align="center">
            <Box flex={{ shrink: 0 }} pad={{ horizontal: 'xxsmall' }} width="90%">
                <HorizontalLine color="grey" />
                <PointAttributes
                    objectName={object.name}
                    pointData={formData}
                    pointDisplayValues={formDisplayValues}
                    providerName={provider.entity.name}
                />
                <HorizontalLine color="grey" />
            </Box>
            <Box
                direction="row"
                gap="medium"
                pad={{ bottom: 'small', horizontal: 'medium' }}
                height="100%"
                width="100%"
                overflow="auto"
                style={{ position: 'unset' }}
            >
                <Box alignSelf="stretch" flex>
                    <Box flex={{ shrink: 0 }}>
                        {points.map((point, index) => (
                            <Box align="center" direction="row" key={point._leaflet_id}>
                                <Box margin={{ vertical: 'small' }} width="100%">
                                    {/* eslint-disable-next-line max-len */}
                                    <Text>
                                        {`${String(index + 1).padStart(2, '0')} - 
                                        ${object.name.charAt(0).toUpperCase() + object.name.slice(1)}`}
                                    </Text>
                                </Box>
                                {index === points.length - 1 && (
                                    <Button alignSelf="center" icon={<Close />} onClick={() => onPointRemove(point)} />
                                )}
                            </Box>
                        ))}
                    </Box>
                    <Box ref={pointsEndRef} />
                </Box>
            </Box>
            <ActionButtons
                onClose={onClose}
                disabled={isEmpty(points)}
                onSave={onSubmit}
            />
        </Box>
    );
};

export default injectIntl(PointForm);
